export const enum Steps {
  FIRST_STEP = 1,
  SECOND_STEP = 2,
  THIRD_STEP = 3
}

export const enum ProductsHandle {
  PACK = 'travel-packs-30-count',
  POUCH = 'ultimate-daily'
}

export const enum ProductTypeCheckout {
  subscription = 'subscription',
  oneTime = 'oneTime'
}

export const enum ProductQtyCheckout {
  single = 1,
  double = 2,
  triple = 3
}

export const enum ProductTypeOption {
  FIRST_PRODUCT = 'first',
  SECOND_PRODUCT = 'second'
}

export const FREQUENCY_INTERVAL = 30;
